<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17OrJkI/media/FC-9781528961004.jpg?1684515369253" alt="This image is the cover for the book Scarred"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scarred
      </h1>
      <p class="bookDescription body article font2">
        <p>Returning to the fantastical land of 'Solari', 15-year-old Evie Campbell is left reeling when a shocking turn of events leaves all of the inhabitants in a state of utter devastation. 	So intent is she on helping her friends that she remains oblivious to the horror that is unfolding in her own world and to the terrifying ordeal that awaits her return…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julia Crothers
      </h2>
      
      <p class="authorDescription body article">Julia Crothers was born and raised in Cardiff, South Wales, where she currently lives with her husband and five children. Having worked with children for most of her adult life, she has now turned her attention to writing. Her current novel, 'Scarred', follows on from the success of her first novel, 'Solari', which was published in 2016.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41a5c9ac